import { render, staticRenderFns } from "./PaymentSettings.vue?vue&type=template&id=0d9c6d1b&scoped=true"
import script from "./PaymentSettings.vue?vue&type=script&lang=js"
export * from "./PaymentSettings.vue?vue&type=script&lang=js"
import style0 from "./PaymentSettings.vue?vue&type=style&index=0&id=0d9c6d1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9c6d1b",
  null
  
)

export default component.exports